import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useFiles } from "@/context/FilesContext";
import { FileBrowser } from "@/components/files/FileBrowser";

export default function Shared() {
  const [data, setData] = useState(null);
  const { refreshKey } = useFiles();
  const load = () => api.get("/shared").then((r) => setData(r.data));
  useEffect(() => { load(); }, [refreshKey]);
  return (
    <div className="max-w-7xl mx-auto fade-up" data-testid="shared-page">
      <p className="text-xs uppercase tracking-wider font-semibold text-slate-500">Collaboration</p>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mt-1 mb-6">Partagés avec moi</h1>
      {data && <FileBrowser folders={data.folders} files={data.files} onChanged={load} emptyText="Aucun document ne vous a encore été partagé." />}
    </div>
  );
}
